document.addEventListener("DOMContentLoaded", () => {
  const sizeChart = document.getElementById("product-size-chart");
  if (!sizeChart) return;

  // 「商品特長」の見出しを探す
  const heading = [...document.querySelectorAll(".product-description-heading.high")]
    .find((el) => el.textContent.trim() === "商品スペック");

  if (!heading) return;

  // 商品特長のコンテンツ取得
  const featureElements = [];
  let node = heading.nextElementSibling;

  while (node) {
    if (
      node.classList &&
      node.classList.contains("product-description-heading")
    ) {
      break;
    }

    featureElements.push(node);
    node = node.nextElementSibling;
  }
  heading.classList.add("tab");
  // タブ化
  heading.innerHTML = `
    <span class="product-description-tab active" data-tab="feature">商品スペック</span>
    <span class="product-description-tab" data-tab="size">年齢別ボール<br class="sp">サイズ早見表</span>
  `;

  const tabs = heading.querySelectorAll(".product-description-tab");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const showFeature = tab.dataset.tab === "feature";

      featureElements.forEach((el) => {
        el.style.display = showFeature ? "" : "none";
      });

      sizeChart.style.display = showFeature ? "none" : "block";
    });
  });
});